import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

const StagePicker = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const onClick = () => {
		if(props.click_action != undefined) props.click_action();
	};

	let classes = ['single_item'];
	if(props.is_selected != undefined && props.is_selected) classes.push('is_selected');

	const display_status = ['open','closed','pending'].includes(props.status);
	
	return (
		<div class={classes.join(" ")} onClick={() => onClick()}>
			<div class={'item_img ' + props.icon} />

			<div class="item_cont">
				<strong class={'item_title' + ((props.status != undefined) ? ' with_status' : '')}>
					{props.title}
					{(props.participations > 0) && (
						<span><span> (<FormattedMessage id="{total} participants" values={{total:props.participations}} />)</span></span>
					)}
				</strong>

				{(props.description != undefined && props.description != "") && (
					<p class="item_description">{props.description}</p>
				)}

				{(display_status) && (
					<span class="item_status gui_ribbons"><span class="ribbon">{props.status}</span></span>
				)}
			</div>
		</div>
	);
}

export default injectIntl(StagePicker);